export const faqs = [
  {
    q: 'How will I receive the materials?',
    a: ["Immediately after your purchase, you'll receive instructions to access and download TCM Diagnostic Blueprint™ and all five bonuses in digital format."],
  },
  {
    q: 'Is this a video course?',
    a: [
      'No. TCM Diagnostic Blueprint™ is a downloadable reference system built around visual maps, structured workflows, checklists, worksheets, and documentation templates.',
      "It's designed to be consulted when you need it rather than requiring you to complete hours of recorded lessons.",
    ],
  },
  {
    q: 'Is this suitable for beginners?',
    a: [
      'The system is intended primarily for automotive electronics technicians and professionals who already have some familiarity with TCMs and automotive diagnostics.',
      'It is not a substitute for foundational technical training or supervised hands-on experience.',
    ],
  },
  {
    q: 'Do I need specific diagnostic tools or programmers?',
    a: [
      'The product helps you organize tool requirements and compatibility checks. It does not require you to purchase a particular brand or model.',
      'You must verify that your equipment supports the specific module, vehicle, and procedure involved.',
    ],
  },
  {
    q: 'Does this teach me how to diagnose every TCM fault?',
    a: [
      'No single general-purpose reference can reliably diagnose every fault across all TCMs and transmission platforms.',
      'The system helps you organize your investigation, document findings, and determine what information or checks are needed next.',
      'Specific procedures must be verified against the applicable technical documentation.',
    ],
  },
  {
    q: 'Does it cover every vehicle manufacturer?',
    a: [
      'The system provides general identification and diagnostic organization frameworks. It is not a verified database of every manufacturer, transmission, TCM, or tool compatibility.',
      'Vehicle-specific procedures and specifications must be checked using appropriate technical references.',
    ],
  },
  {
    q: 'Does it teach security bypasses or unauthorized access?',
    a: ['No. The product focuses on diagnostic organization, documentation, preparation, and verification. Any work involving security-related functions must comply with applicable laws and manufacturer procedures.'],
  },
  {
    q: 'Are the files downloadable?',
    a: ['Yes. The product is delivered digitally so you can save the materials and consult them on a compatible device. Printable resources can be printed for workshop use.'],
  },
  {
    q: 'Is this a one-time payment?',
    a: ['Yes. The launch price is $27 USD as a one-time payment. There is no recurring monthly subscription.'],
  },
  {
    q: "What if I don't like it?",
    a: ['You can request a refund within the applicable seven-day guarantee period, subject to the published refund terms.'],
  },
  {
    q: 'Can I use it in my workshop?',
    a: ['The materials are designed as practical references for workshop use. You can adapt the documentation templates to your workflow while continuing to follow applicable safety procedures, manufacturer instructions, and technical requirements.'],
  },
]
